import Cookies from "js-cookie";

import { LOG_OFF_API, PROD_AUTH_BASE_URL } from "constants/auth.constants";
import { ZoneUserRole } from "constants/userContstants";
import * as LOCAL_STORAGE from "utils/localStorage";

export const generateState = () => {
  const validChars =
    "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789";

  const codePoints = [...globalThis.crypto.getRandomValues(new Uint8Array(56))]
    .map((x) => validChars.codePointAt(x % validChars.length))
    .filter((val) => val !== undefined);

  return String.fromCodePoint(...codePoints);
};

export const shouldRefreshAccessToken = (roles: string[]) => {
  return roles.length === 1 && roles.includes(ZoneUserRole.SERVICE_MONITOR);
};

export const enhanceAuthorizeUrl = ({
  clientId,
  state,
  codeChallenge,
  authorizeUrl,
  redirectUri,
  loginHint,
}: {
  clientId: string;
  state: string;
  codeChallenge: string;
  authorizeUrl: string;
  redirectUri: string;
  loginHint: string;
}) => {
  const redirectURI = `${document.location.origin}${redirectUri}`;

  const url = new URL(authorizeUrl);

  url.searchParams.set("response_type", "code");
  url.searchParams.set("scope", "offline_access");
  url.searchParams.set("code_challenge_method", "S256");
  url.searchParams.set("client_id", clientId);
  url.searchParams.set("state", state);
  url.searchParams.set("code_challenge", codeChallenge);
  url.searchParams.set("redirect_uri", redirectURI);
  url.searchParams.set("login_hint", loginHint);

  return url.toString();
};

export async function generateCodeChallenge(codeVerifier: string) {
  const encoder = new TextEncoder();
  const data = encoder.encode(codeVerifier);
  const digest = await globalThis.crypto.subtle.digest("SHA-256", data);
  const base64Digest = btoa(String.fromCodePoint(...new Uint8Array(digest)));

  return base64Digest
    .replaceAll("+", "-")
    .replaceAll("/", "_")
    .replaceAll("=", "");
}

export const clearCookies = () => {
  Cookies.remove("access_token");
  Cookies.remove("refresh_token");
  Cookies.remove("userId");
};

export const getLogoutUrl = () => {
  const client_id = LOCAL_STORAGE.getClientId();

  return `${getAuthBaseUrl() + LOG_OFF_API}?client_id=${client_id}`;
};

export const getAuthBaseUrl = () => {
  if (import.meta.env.VITE_AUTH_BACKENDS) {
    return LOCAL_STORAGE.getCustomAuthBackend() ?? PROD_AUTH_BASE_URL;
  }

  return PROD_AUTH_BASE_URL;
};
